<template>
  <div>
    <formula-head :details="details" />
    <formula-base :details="details" />
    <!-- <formula-tabs /> -->
    <formula-add :rowId="formulaId" :factoryId="factoryId" />

    <formula-additional-raw :rowId="formulaId" :factoryId="factoryId" />

  </div>
</template>

<script>
import FormulaHead from './FormulaAdministration/FormulaHead.vue'
import FormulaBase from './FormulaAdministration/FormulaBase.vue'
// import FormulaTabs from './FormulaAdministration/FormulaTabs.vue'
import FormulaAdd from './FormulaAdministration/FormulaAdd.vue'
import FormulaAdditionalRaw from './FormulaAdministration/FormulaAdditionalRaw.vue'
import { getRequest } from "@/components/Common/Utils/Utils.js";
export default {
  components: {FormulaHead,FormulaBase,FormulaAdd,FormulaAdditionalRaw},
  data(){
    return {
      details: {},
      formulaId: getRequest('id'),
      factoryId: getRequest('factoryId'),
    }
  },
  mounted(){
    this.getDetail()
  },
  methods:{
    getDetail() {
      this.$http.get('/nhf-app/archivedFormula/detail',{params: {formulaId: this.formulaId}}).then(res => {
        if(res?.data){
          this.details = res.data
        }
      })
    },
  }
}
</script>
